import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

export const FormLabel: ComponentStyleConfig = {
  baseStyle: (props: Dict) => ({
    color: mode('rw1.text.light.2', 'rw1.text.dark.2')(props),
    fontSize: 'sm',
  }),
}
